export default "<app-pie-slices [nOfSlices]=\"fraction.denominator\" [markedOnes]=\"markedOnes\"></app-pie-slices>"